type ReduceQueriesResult<T> = T & { isLoading: boolean };

// Helper to wait for completion of a number of API requests.
export function reduceQueries<T>(queries: T): ReduceQueriesResult<T> {
  return {
    ...queries,
    isLoading: Object.values(queries).some(({ isLoading }) => !!isLoading),
  };
}
